import React from "react";
import tw from "twin.macro";
import Decription from "components/features/TwoColDescriptionProducts";

// Import images
import nivelManualInstalacao from "assets/nivel_manual_instalacao.png";


export default () => {
  const Subheading = tw.span`uppercase tracking-widest font-bold text-primary-500`;

  return (
    <>
      <Decription
        subheading={<Subheading>Manual de instalação Sensor de Nível</Subheading>}
        imageSrc={[nivelManualInstalacao]}
        imageBorder={false}
        imageShadow={false}
        imageDecoratorBlob={true}
        description={["\
          Siga o desenho unifilar para realizar a instalação do Sensor. Se atente na necessidade de utilizar um Contator e não ligar o Motor/Equipamento diretamente no Sensor.\
          A instalação e a especificação do Contato deverão ser feitos por um Técnico Eletricista.\
          Antes de posicionar o Sensor no Reservatório, é recomentado que seja feito a instalação do Sensor no Aplicativo em seu celular (https://play.google.com/store/apps/details?id=com.emsamts).\
          É possível retornar o Sensor para os dados originais de fábrica, mantendo pressionado o botão na lateral do sensor por mais de 10 segundos.\
        "]}
        heading="Como instalar o seu Sensor mTs de nível"
      />
    </>
  );
}
